/* eslint-disable */
import { Back, Power2 } from 'gsap';

export const EffectsList = [
  {
    id: 'fadeIn',
    name: 'Fade in',
    category: 'Fade',
    set: { opacity: 0 },
    to: { opacity: 1 },
  },
  {
    id: 'fadeInDown',
    name: 'Fade in down',
    category: 'Fade',
    set: { opacity: 0, y: '-100px' },
    to: { opacity: 1, y: 0 },
  },
  {
    id: 'fadeInRight',
    name: 'Fade in right',
    category: 'Fade',
    set: { opacity: 0, x: '100px' },
    to: { opacity: 1, x: 0 },
  },
  {
    id: 'fadeInUp',
    name: 'Fade in up',
    category: 'Fade',
    set: { opacity: 0, y: '100px' },
    to: { opacity: 1, y: 0, duration: 0.5 },
  },
  {
    id: 'fadeInLeft',
    name: 'Fade in left',
    category: 'Fade',
    set: { opacity: 0, x: '-100px' },
    to: { opacity: 1, x: 0 },
  },
  {
    id: 'slideInDown',
    category: 'Slide',
    name: 'Slide in down',
    set: { y: '-100px' },
    to: { y: 0 },
  },
  {
    id: 'slideInRight',
    name: 'Slide in right',
    category: 'Slide',
    set: { x: '100px' },
    to: { x: 0 },
  },
  {
    id: 'slideInRightBig',
    name: 'Slide in right big',
    category: 'Slide',
    to: { x: 0, ease: Power2.easeOut },
    defaults: { duration: 1 },
    offScreen: 'right',
  },
  {
    id: 'slideInUp',
    name: 'Slide in up',
    category: 'Slide',
    set: { y: '100px' },
    to: { y: 0 },
  },
  {
    id: 'slideInLeft',
    name: 'Slide in left',
    category: 'Slide',
    set: { x: '-100px' },
    to: { x: 0 },
  },
  {
    id: 'slideInLeftBig',
    name: 'Slide in left big',
    category: 'Slide',
    to: { x: 0, ease: Power2.easeOut },
    defaults: { duration: 1 },
    offScreen: 'left',
  },
  {
    id: 'zoomIn',
    name: 'Zoom in',
    category: 'Zoom',
    set: { scale: 0 },
    to: { scale: 1, ease: Back.easeOut },
    defaults: { duration: 0.75 },
  },
  {
    id: 'flipInX',
    name: 'Flip in X',
    category: 'Flip',
    set: {
      transformStyle: 'preserve-3d',
      backfaceVisibility: 'hidden',
      transformPerspective: '500px',
      rotateX: -100,
      opacity: 0,
    },
    to: { rotationX: 0, opacity: 1, ease: Back.easeOut },
    defaults: { duration: 0.75 },
  },
  {
    id: 'flipInY',
    name: 'Flip in Y',
    category: 'Flip',
    set: {
      transformStyle: 'preserve-3d',
      backfaceVisibility: 'hidden',
      transformPerspective: '500px',
      rotateY: -100,
      opacity: 0,
    },
    to: { rotationY: 0, opacity: 1, ease: Back.easeOut },
    defaults: { duration: 0.75 },
  },
];
